module.exports = __webpack_public_path__ + "img/menucn_4_1.7178f2f8.svg";